import { ElementType } from 'react';
import {
  Experiment,
  ExperimentVariant,
  ExperimentControl,
} from '@nerdwallet/features';
import { StructuredContentNode } from '@nerdwallet/structured-content-core';

export const renderNodeWithABTesting = (
  node: StructuredContentNode,
  Component: ElementType
) => {
  if (node.props?.ABTesting?.enabled) {
    return (
      <Experiment testName={node.props?.ABTesting?.testName}>
        {/* Control */}
        {node.props?.ABTesting?.name === 'control' && (
          <ExperimentControl>
            <Component {...node.props} />
          </ExperimentControl>
        )}
        {/* Variants */}
        {node.props?.ABTesting?.name && (
          <ExperimentVariant name={node.props?.ABTesting?.name}>
            <Component {...node.props} />
          </ExperimentVariant>
        )}
      </Experiment>
    );
  }
  return <Component {...node.props} />;
};

const ABTestingHelpElement = (
  <a
    href="https://nerdwallet.atlassian.net/wiki/x/F4Bzmw"
    target="_blank"
    rel="noopener noreferrer"
  >
    Check out the chrome extension!
  </a>
);

export const ABTestingFormConfig = [
  {
    label: 'Enable A/B Testing',
    viewType: 'checkbox',
    value: '{{0}}',
    help: ABTestingHelpElement,

    options: [
      {
        label: 'Enable A/B Testing',
        value: 'true',
        disabled: false,
      },
    ],
    keys: [
      {
        key: 'form.props.ABTesting.enabled',
      },
    ],
    elements: [],
  },
  {
    label: 'Test Name',
    viewType: 'input',
    value: '{{0}}',
    subType: 'text',
    formatType: 'none',
    keys: [
      {
        key: 'form.props.ABTesting.testName',
      },
    ],
    elements: [],
  },
  {
    label: 'Variant Name',
    viewType: 'input',
    value: '{{0}}',
    subType: 'text',
    formatType: 'none',
    keys: [
      {
        key: 'form.props.ABTesting.name',
      },
    ],
    elements: [],
  },
];
